import React from 'react';
import { FaApple, FaGooglePlay, FaCar } from 'react-icons/fa';

const DownloadApp = () => {
  return (
    <section className="bg-slate-950 py-16 px-4 sm:px-6 lg:px-8 min-h-screen flex items-center">
      <div className="mx-auto w-full">
        {/* Updated: Added the hover and scale effect classes to the main container */}
        <div className="bg-slate-800 rounded-3xl p-8 md:p-16 grid grid-cols-1 md:grid-cols-2 gap-12 items-center overflow-hidden relative ring-4 ring-amber-400/50 shadow-2xl transition-all duration-300 ease-in-out hover:shadow-[0_0_50px_10px_rgba(251,191,36,0.5)] hover:scale-[1.02]">
          
          <FaCar className="absolute -left-20 -bottom-20 text-slate-700 opacity-20" style={{ fontSize: '25rem' }} />

          <div className="relative h-96 md:h-[500px] flex justify-center items-center">
            <div className="relative w-64 h-[500px] rounded-[40px] border-8 border-slate-900 shadow-2xl overflow-hidden animate-pulse">
              <div className="absolute top-0 left-0 w-full h-8 bg-slate-900 flex justify-center items-end">
                  <div className="w-1/3 h-3 bg-slate-800 rounded-b-lg"></div>
              </div>
              <div 
                className="h-full w-full"
                style={{ backgroundImage: "url('/assets/mobile-car.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}
              >
              </div>
            </div>
          </div>

          <div className="relative z-10 text-white">
            <p className="font-semibold text-slate-400 mb-2 uppercase">Download our app</p>
            <h2 className="text-4xl font-bold mb-4 text-amber-400">
              Download our app
            </h2>
            <p className="text-slate-400 mb-8 max-w-md">
              Turpis morbi enim nisl, pulvinar leo duis tellus. Faucibus egestas semper
              diam rutrum, dictumsed id donec. Nisl nisl morbi vel, in vulputate.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="#" 
                className="bg-slate-900 text-white px-5 py-3 rounded-lg flex items-center justify-center gap-3 transition hover:bg-slate-800"
              >
                <FaApple size={24} />
                <span>App Store</span>
              </a>
              <a 
                href="#" 
                className="bg-slate-900 text-white px-5 py-3 rounded-lg flex items-center justify-center gap-3 transition hover:bg-slate-800"
              >
                <FaGooglePlay size={20} />
                <span>Google Play</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DownloadApp;